<template>
  <div id="intent">
    <template v-if="!loading">
      <v-container>
        <slot name="header"></slot>
        <v-layout wrap v-if="intents.length > 1 && !isGetstarted">
          <v-flex xs12 sm6 class="form-control">
            <input
              type="text"
              v-model="search"
              class="form-control"
              :placeholder="$t('Search Conversation Name')"
              style="margin-bottom: 10px"
            />
          </v-flex>
          <v-flex xs12 sm6 class="form-control text-xs-right">
            <v-btn class="ma-0 mb-1 mr-1" @click="expandAll" color="primary" outline>
              <em class="fas fa-expand-arrows-alt mr-1" />
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 mr-1" @click="collapseAll" color="primary" outline>
              <em class="fas fa-compress mr-1" />
              {{ $t('Collapse All') }}
            </v-btn>
            <v-btn
              class="ma-0 mb-1 mr-1"
              @click="exportIntents"
              color="primary"
              outline
              v-if="selectedBot && selectedBot.type === 'gpf'"
            >
              <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)" class="my-3">
          <v-layout v-if="!livechat">
            <v-flex xs10>
              <h6 class="headline mb-2">{{ $t('Conversation Grouping') }}</h6>
              <!-- <v-btn
                :key="'all'"
                class="ma-0 mr-1 mb-1"
                depressed
                :outline="currentFilterGroup != 'all'"
                :color="currentFilterGroup == 'all' ? 'primary' : 'grey'"
                @click="onFilterGroupChange('all')"
                >All</v-btn
              > -->
              <!-- {{ filterGroupConversation }} -->
              <template v-for="option in filterGroupConversation">
                <v-btn
                  v-if="option.status"
                  :key="option.id"
                  class="ma-0 mr-1 mb-1"
                  depressed
                  :outline="currentFilterGroup != option.id"
                  :color="currentFilterGroup == option.id ? 'primary' : 'grey'"
                  @click="onFilterGroupChange(option.id)"
                  >{{ option.name }}</v-btn
                >
              </template>
            </v-flex>
            <v-flex xs2 class="text-xs-right">
              <v-btn fab outline color="primary" class="extra-small mt-2" @click="showGroup = true">
                <em class="fas fa-pencil-alt" />
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-else>
            <v-flex xs12>
              <div class="caption mt-2">{{ $t('Conversation Grouping') }}</div>
              <multiselect
                v-model="livechatFilterGroupConversation"
                :options="filterGroupConversation"
                selectLabel
                selectedLabel
                :searchable="true"
                deselect-label
                label="name"
                track-by="id"
                :allowEmpty="false"
                @input="onLivechatFilterGroupConversation"
              ></multiselect>
            </v-flex>
          </v-layout>
          <ConversationGrouping
            v-model="grouplist"
            @close="showGroup = false"
            :show="showGroup"
            @onCategoryChange="onCategoryChange"
            @deleteCategory="deleteCategory"
          ></ConversationGrouping>
        </div>

        <template v-if="!livechat || ['ticket2', 'studio7', 'ustore'].includes(selectedBot.theme)">
          <div v-if="!isShow" :style="`margin-bottom: 10px; position: relative;`">
            <a href="javascript:void(0);" @click="addConversation" style="text-decoration: none">
              <div class="add-conversation text-xs-center">
                <em class="fa fa-plus middle" />
                {{ $t('Add conversation') }}
              </div>
            </a>
          </div>

          <div class="mb-4" v-if="selectedBot.theme == 'universalutilities'">
            <div v-if="selectedBot.uu_areaname" class="primary--text">
              {{ selectedBot.uu_areaname }}
            </div>
            <template v-else>
              <multiselect
                v-model="uuAreaName"
                :options="areaName"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                data-vv-as="ประปา"
                data-vv-name="uuAreaName"
                v-validate="'required'"
                @select="onSelectUuAreaName"
              ></multiselect>
            </template>
          </div>
          <div class="intent-item z-border-red" v-if="isShow" style="padding: 10px 15px 0px">
            <manage-intent
              :livechat="livechat"
              :type="'add'"
              v-model="intent"
              @close="onClose"
              @saveIntent="onSaveIntent"
              :excludedIntentName="excludedIntentName"
            ></manage-intent>
          </div>
        </template>
        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <v-pagination :total-visible="15" v-model="pageNumber" :length="pageCount"></v-pagination>
        </div>
        <!-- <transition-group
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:leave="leave"
        > -->

        <intent-item
          :livechat="livechat"
          @sendToLivechat="sendToLivechat"
          v-for="(item, index) in finalIntent"
          :key="'intent_' + item.id + '_' + index"
          v-model="finalIntent[index]"
          :filterIntents="finalIntent"
          @onDelete="deleteIntent(index)"
          @onCopyIntent="copyIntent"
          :excludedIntentName="excludedIntentName"
          @onUpdate="onUpdateIntent"
          @onFetchAll="handleFetchIntents"
        ></intent-item>
        <!-- </transition-group> -->

        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <v-pagination :total-visible="15" v-model="pageNumber" :length="pageCount"></v-pagination>
        </div>
      </v-container>
      <template v-if="showDefault">
        <v-divider></v-divider>

        <v-container>
          <h3 class="headline">{{ $t('Default Conversation') }}</h3>
          <intent-item v-model="default_intent" :welcomemessage="welcome_message"></intent-item>
        </v-container>
      </template>
      <div class="mt-5 mb-5"></div>
    </template>
    <div v-else>
      <v-layout justify-center column fill-height style="min-height: 300px">
        <scale-loader
          :loading="true"
          :color="$vuetify.theme.primary"
          height="45px"
          width="7px"
        ></scale-loader>
      </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import hopinnHrApi from '@/api/hopinn-hr'
import cloneDeep from 'lodash/cloneDeep'
import Velocity from 'velocity-animate'
import Multiselect from 'vue-multiselect'
import ConversationGrouping from './ConversationGrouping'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import intentItem from './intent-item'
import manageIntent from './intent-manage'
import XLSX from 'xlsx'
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'

export default {
  props: {
    showDefault: {
      default: true,
      type: Boolean
    },
    isGetstarted: {
      default: false,
      type: Boolean
    },
    filterContext: {
      default: null
    },
    pageid: {
      default: null
    },
    livechat: {
      default: false
    }
  },
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    Multiselect,
    ScaleLoader,
    ConversationGrouping
  },
  data() {
    return {
      showPagination: false,
      pageNumber: 1,
      isShow: false,
      showsize: 50,
      showModal: false,
      uuAreaName: '',
      loading: true,
      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        follow_up_fb_quick_reply: null,
        follow_up_fb_val: null,
        follow_up_ig_quick_reply: null,
        follow_up_ig_val: null,
        follow_up_line_quick_reply: null,
        follow_up_line_val: null,
        follow_up_quick_reply: null,
        follow_up_status: null,
        follow_up_type: null,
        follow_up_val: null,
        follow_up_within_seconds: null
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_intent: undefined,
      currentpageid: null,
      grouplist: undefined,
      showGroup: false,
      currentFilterGroup: 'all',
      livechatFilterGroupConversation: [{ id: 'all', name: 'All', status: true }]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageCount: function () {
      let l = this.filterIntents.length
      let s = this.showsize
      return Math.ceil(l / s)
    },
    filterIntents: function () {
      var vm = this
      var intents = vm.intents
      if (this.filterContext)
        intents = intents.filter((el) => {
          return el.context_in == this.filterContext
        })
      // if (vm.selectedBot.theme !== 'tero') {
      //   intents.sort(function (a, b) {
      //     var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
      //     var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
      //     if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
      //       return 1
      //     }
      //     if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
      //       return -1
      //     }
      //     if (nameA < nameB) {
      //       return -1
      //     }
      //     if (nameA > nameB) {
      //       return 1
      //     }

      //     // names must be equal
      //     return 0
      //   })
      // }

      var filteredIntent = intents.filter((intent) => {
        var isFound =
          (this.livechat || intent.q_val !== 'exacts(intent_type_quick_message)') &&
          ((intent.intentname &&
            intent.intentname.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.q_val && intent.q_val.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_in &&
              intent.context_in.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_out &&
              intent.context_out.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.a_val && intent.a_val.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.id && intent.id.includes(vm.search))) &&
          !['comment', 'facebooklive'].includes(intent.context_in)

        return isFound
      })
      return filteredIntent
    },
    finalIntent() {
      if (this.filterIntents.length >= 100) {
        this.showPagination = true
        var start = (this.pageNumber - 1) * this.showsize
        var end = this.pageNumber * this.showsize
        var result = this.filterIntents.slice(start, end)
        return result
      } else {
        this.showPagination = false
        return this.filterIntents
      }
    },

    excludedIntentName: function () {
      var result = []
      var vm = this
      $.each(vm.allIntents, function (index, intent) {
        result.push(intent.intentname)
      })
      return result.join(',')
    },
    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    },
    filterGroupConversation() {
      var group = [{ id: 'all', name: 'All', status: true }]
      var groupConversation = this.$store.state.groupConversation
      group.push(...groupConversation)
      return group
    }
  },
  async mounted() {
    var vm = this
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }

    this.loading = true
    if (this.$store.state.toaPaintPage.includes(this.selectedBot.pageid)) {
      await this.$store.dispatch('loadGroupConversation')
      this.grouplist = this.$store.state.groupConversation
    }
    this.getLineNotify()
    try {
      await this.getWelcomeMessage()
    } catch (error) {}
    await this.getIntent()
    this.$emit('getIntent', this.intents)
    this.loading = false

    if (vm.selectedBot && vm.selectedBot.type === 'hopinnhr') {
      await vm.getHopinnHrAffiliation()
      await vm.getHopinnHrPosition()
    }

    if (['powerbuy'].includes(vm.selectedBot.theme)) {
      await vm.handlePowerbuyCheckBranch()
    }

    if (
      (this.selectedBot.theme == 'ecommercebasic' ||
        this.$store.state.shoptheme.includes(this.selectedBot.theme)) &&
      !['allinonechat'].includes(this.$route.name)
    ) {
      await this.$store.dispatch('loadCategory')
      await this.$store.dispatch('loadProducts')
      await this.$store.dispatch('loadCharges')
    }
    if (
      ['ticket', 'ticket2', 'studio7', 'ustore', 'cityfresh'].includes(this.selectedBot.theme) ||
      [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
        this.selectedBot.pageid
      ) ||
      ['gpf', 'mtc'].includes(this.selectedBot.type)
    ) {
      await this.$store.dispatch('loadAgents')
      await this.$store.dispatch('loadAgentGroups')
      await this.$store.dispatch('loadAgentSubGroups')
    }

    if (['mitsuwebchat'].includes(this.selectedBot.theme)) {
      await this.$store.dispatch('loadAgentGroups')
    }

    if (['toa'].includes(this.selectedBot.theme)) {
      this.$store.dispatch('getTicketTags')
    }

    this.$store.dispatch('loadSetting')
  },
  methods: {
    sendToLivechat(intent) {
      this.$emit('sendToLivechat', intent)
    },
    onSelectUuAreaName: function (type) {
      var vm = this
      vm.$store.dispatch('loading')
      vm.uuAreaName = type == 'ทุกพื้นที่' ? '' : type
      vm.getIntent(function () {
        vm.$store.dispatch('loading')
      })
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.currentpageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.$store.state.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function (payload) {
      // console.log(payload)
      var vm = this
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      vm.allIntents.push(payload)

      vm.intent = cloneDeep(this.intentTemplate())
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
    },
    copyIntent: function (payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.currentpageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then((result) => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.intentname.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function (payload) {
      this.isShow = false
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      // this.intents.push(payload)
      // this.getIntent()
    },
    getIntent: function () {
      const vm = this
      let auth = null
      let data = {
        pageid: vm.currentpageid
      }

      return new Promise((resolve, reject) => {
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.intentgroup = vm.selectedBot.uu_areaname
          } else if (vm.uuAreaName != '') {
            data.intentgroup = vm.uuAreaName
          }
        }

        if (['mitsuwebchat'].includes(vm.selectedBot.theme)) {
          if (vm.$store.state.privilege.role !== 'superadmin' && vm.$store.state.admingroupid) {
            data.intentgroup = vm.$store.state.admingroupid
          }
        }

        if (vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)) {
          if (vm.currentFilterGroup !== 'all') {
            data.group_conversation_id = vm.currentFilterGroup
          }
        }

        api.getIntent(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.responsecode == 200) {
            var intents = response.data.map(function (val) {
              var intent = { ...val }
              intent.isShow = false
              intent.ableToDelete = true
              return intent
            })
            vm.allIntents = intents
            vm.intents = intents.filter((el) => {
              return (
                el.context_in != 'comment' &&
                el.intentname != '{default}' &&
                el.intentname != '{welcome}'
              )
            })

            var default_intent = intents.find((el) => {
              return el.intentname == '{default}'
            })

            if (default_intent) {
              default_intent.ableToDelete = false
              vm.default_intent = default_intent
            } else {
              vm.default_intent = {
                ...cloneDeep(vm.intentTemplate()),
                intentname: '{default}',
                ableToDelete: false
              }
            }
          }
          resolve()
        })
      })
    },
    deleteIntent: function (index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.finalIntent[index].intentname.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let data = {
              id: vm.finalIntent[index].id,
              pageid: vm.currentpageid
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              $.each(vm.intents, function (intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })
              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function (el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    getWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.currentpageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.welcome_message.type = response.data.type
            vm.welcome_message.message = response.data.message_text
              ? response.data.message_text
              : ''

            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function (index, val) {
                vm.welcome_message.generics[index] = val
              })
            }

            if (
              response.data.message_quickreplies &&
              response.data.message_quickreplies != '' &&
              response.data.message_quickreplies != null
            ) {
              vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
            } else {
              vm.welcome_message.quick_reply = []
            }
          }
          resolve()
        })
      })
    },
    addConversation() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.currentpageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    expandAll: function () {
      var vm = this
      vm.intents.forEach((el, index) => {
        vm.$set(vm.intents[index], 'isShow', true)
      })
      vm.$set(vm.default_intent, 'isShow', true)
    },
    collapseAll: function () {
      var vm = this

      vm.intents.forEach((el, index) => {
        vm.$set(vm.intents[index], 'isShow', false)
      })
      vm.$set(vm.default_intent, 'isShow', false)
    },
    onUpdateIntent: function (payload) {
      const vm = this
      const index = vm.intents.findIndex((el) => {
        return el.id == payload.id
      })
      if (index > -1) {
        vm.$set(vm.intents, index, payload)
      }
    },
    onFilterGroupChange: function (value) {
      let vm = this
      vm.currentFilterGroup = value
      vm.getIntent(function () {
        vm.$store.dispatch('loading')
      })
    },
    onLivechatFilterGroupConversation(value) {
      let vm = this
      let currentFilterId = value.id
      vm.currentFilterGroup = value.id

      let selectedConversationGroup = this.filterGroupConversation.find(
        (el) => el.id == currentFilterId
      )
      this.$set(this.livechatFilterGroupConversation, selectedConversationGroup)
      vm.getIntent(function () {
        vm.$store.dispatch('loading')
      })
    },
    onCategoryChange: function () {
      let vm = this
    },
    deleteCategory(groupid) {
      this.grouplist = this.grouplist.filter((el) => {
        return el.id != groupid
      })
      if (this.currentFilterGroup == groupid) {
        this.setDefaultCategory()
      }
    },
    setDefaultCategory() {
      if (this.selectedBot.theme == 'nvbb' && this.categorylist.length > 0) {
        this.currentFilterGroup = this.categorylist[0].id
      } else {
        this.currentFilterGroup = 'all'
      }
    },
    async getHopinnHrAffiliation() {
      const vm = this
      try {
        const response = await hopinnHrApi.getAffiliation()
        if (response && response.data.responsecode == 200) {
          vm.$store.state.hopinnMasterData.affiliation = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getHopinnHrPosition() {
      const vm = this
      try {
        const response = await hopinnHrApi.getPosition()
        if (response && response.data.responsecode == 200) {
          vm.$store.state.hopinnMasterData.position = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    exportIntents() {
      const vm = this
      const allIntents = vm.allIntents
      const intents = allIntents.map((el) => {
        return {
          id: el.id,
          intent_name: el.intentname,
          question: el.q_val,
          answer: el.a_val,
          status: el.intentstatus == true ? 'Active' : 'Inactive'
        }
      })
      const heading = [['Id', 'Intent Name', 'Question', 'Answer', 'Status']]
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, intents, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `GPF-intents.xlsx`)
    },
    async handlePowerbuyCheckBranch() {
      const vm = this
      try {
        let data = {
          pageId: vm.selectedBot.pageid
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.checkBranch({
          config: {
            params: data
          }
        })

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.$store.state.powerbuyMainBranch = response.data.shop_main_pageid
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleFetchIntents() {
      this.$store.dispatch('loading')
      await this.getIntent(function () {})
      this.$store.dispatch('loading')
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      // if (newVal != oldVal) this.getIntent(function() {})
    }
  }
}
</script>

<style>
.intentmax {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Intent.vue